import { FC, useEffect } from "react";

import { config } from "config/config";

import { UnsubscribeCard } from "./UnsubscribeCard";

export const EmailUnsubscribeRequester: FC = () => {
  useEffect(() => {
    fetch(`${config.api}/v1/requesters/unsubscribeEmail${window.location.search}`, {
      method: "POST",
      body: JSON.stringify({ "List-Unsubscribe": "One-Click" }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  }, []);

  return (
    <UnsubscribeCard
      title="You've been unsubscribed"
      description="You won't get any more notifications from this sender."
    />
  );
};
